import classes from "./SectionRight.module.css";
import DownloadButton from "../../download-button/DownloadButton";
import {useContext} from "react";
import QRCodeViewItemContext from "../../QRCodeViewItemContext";
import {Image, Stack} from "@mantine/core";
import ScanDetails from "../../scan-details/ScanDetails";
import Menu from "./menu/Menu";
import {useMediaQuery} from "@mantine/hooks";

function SectionRight() {
    /**
     * QRCodeViewItemContext
     * @author Kacper Faber
     * @since 0.1.9
    */
    const ctx = useContext(QRCodeViewItemContext);
    const isSmallScreen = useMediaQuery(("(max-width: 1024px)"));

    return (
        <div className={classes.root}>
           { !isSmallScreen && <ScanDetails/> }

            { !isSmallScreen && <Image
              src={ctx.qrCode?.image}
              height={100}
            /> }

            <Stack gap="xs" justify="end" w={isSmallScreen ? "100%" : "auto"} align={isSmallScreen ? "center" : "stretch"}>
                <DownloadButton/>
                <Menu/>
            </Stack>
        </div>
    );
}

export default SectionRight;